import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ComputedRef, computed } from "vue";
import { ExperimentStatus } from "@/shared/types/experiments";


export default /*@__PURE__*/_defineComponent({
  __name: 'ExperimentStatusTag',
  props: {
    status: {}
  },
  setup(__props: any) {

const props = __props;

const tagTypes = {
  [ExperimentStatus.Draft]: "info",
  [ExperimentStatus.Active]: "success",
  [ExperimentStatus.Stopped]: "danger",
};

const type: ComputedRef<string> = computed(() => tagTypes[props.status]);

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(_component_el_tag, { type: type.value }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.status), 1)
    ]),
    _: 1
  }, 8, ["type"]))
}
}

})